export default function getSectionBorderRadius({ isStart, isEnd }) {
  if (isStart && isEnd) {
    return 'border-radius: 20px;';
  } else if (isStart) {
    return 'border-radius: 20px 20px 0 0;';
  } else if (isEnd) {
    return 'border-radius: 0 0 20px 20px;';
  }

  return '';
}



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/sectionBorderRadius.js